module.exports = __webpack_public_path__ + "6606e0c3824cf25a091ae621180c3f00.pdf";